import type { CartConfig } from '#types/config/components/cart'

export default {
  brandClasses: {
    editItemCta: 'mt-4 flex items-center gap-2 underlined <lg:hidden body-3',
    name: 'subtitle-4',
    pricing: 'body-4',
    variantsContainer: 'body-4 c-grey-20',
    promosContainer: 'eyebrow c-brand-3',
  },
  disableBonusItemPdpLinks: true,
  thumbnails: {
    alignFill: 'center',
    height: { sm: 152 },
    unSharpMask: 100,
    width: { sm: 123 }
  }
} satisfies CartConfig['item']
